import {ResponsiveModal} from '~library/organisms/ResponsiveModal';
import './ValidationModal.sass';

export const ValidationModal = ({goToFirstError, onClose, error}) => (
  <ResponsiveModal
    isOpen={!!error}
    title={error?.title}
    primaryText="Fix my errors"
    primaryAction={goToFirstError}
    showSecondary={false}
    onClose={onClose}
    body={error?.message}
  />
);
